import React from "react"
import CardProduct from "components/global/card-product/card-product"
import imgProduct from "@public/img/sample/product.jpg"
import { useScrollAnim } from "@components/hooks/hooks"

const ResultProductPage = ({ data, wishlists }) => {
  const [trigger, anim] = useScrollAnim()
  return (
    <div className="card-product-list" ref={trigger}>
      {data.map((item, i) => (
        <div key={i} className={`card-product-item ${anim((i + 1) % 10)}`}>
          <CardProduct
            {...item}
            imgAlt={`sale-product-${i}`}
            // wishlists={wishlists}
            noCategory
            listName={"Search Result"}
            index={i + 1}
          />
        </div>
      ))}
    </div>
  )
}

export default ResultProductPage
